import React from 'react';
import { STEPS } from './constants';

function StepIndicator({ currentStep, completedSteps, onStepClick }) {
  return (
    <div className="bg-white border-b border-gray-200">
      <div className="px-8 py-6">
        <div className="flex items-center justify-between">
          {STEPS.map((step, index) => (
            <React.Fragment key={step.id}>
              <div className="flex flex-col items-center flex-1">
                {/* Step Circle */}
                <button
                  onClick={() => onStepClick(step.id)}
                  disabled={step.id > currentStep && !completedSteps.includes(step.id - 1)}
                  className={`relative flex items-center justify-center w-12 h-12 rounded-full border-2 transition-all ${
                    step.id === currentStep
                      ? 'border-purple-600 bg-purple-600 text-white shadow-lg scale-110'
                      : completedSteps.includes(step.id)
                      ? 'border-green-500 bg-green-500 text-white'
                      : 'border-gray-300 bg-white text-gray-400'
                  } ${
                    step.id <= currentStep || completedSteps.includes(step.id - 1)
                      ? 'cursor-pointer hover:scale-105'
                      : 'cursor-not-allowed opacity-50'
                  }`}
                >
                  {completedSteps.includes(step.id) ? (
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  ) : (
                    <span className="text-xl">{step.icon}</span>
                  )}
                </button>

                {/* Step Label */}
                <span className={`mt-2 text-sm font-medium ${
                  step.id === currentStep ? 'text-purple-600' : 'text-gray-600'
                }`}>
                  {step.name}
                </span>
              </div>

              {/* Connector Line */}
              {index < STEPS.length - 1 && (
                <div className={`flex-1 h-0.5 mx-2 -mt-6 ${
                  completedSteps.includes(step.id) ? 'bg-green-500' : 'bg-gray-300'
                }`} />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

export default StepIndicator;
